export default __webpack_public_path__ + "static/media/bp4.ce2a957d.png";